import React from "react";
import {
    Table
} from "reactstrap";
import SubscriptionDeviceRow from './SubscriptionDeviceRow.js';


const SubscriptionsDevicesTable = ({ devices, checkChangedHandler }) => {
    return (
        <>
            <Table borderless className="no-margin-x">
                <thead className="background-color-lightGray">
                    <tr>
                        <th className="text-center  col-2">
                            License Status
                        </th>                      
                        <th className="text-center col-4">
                            Device Name
                        </th>
                        <th className="text-center col-4">
                            Location
                        </th>
                        <th className="col-1">
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {devices.map((item, index) => {
                        return (
                            <SubscriptionDeviceRow key={`DeviceRow${item.accountId}`} device={item} checkChangedHandler={checkChangedHandler} />
                        )
                    })
                    }
                </tbody>
            </Table>
        </>

    );
}

export default SubscriptionsDevicesTable;